import type { ElementType, ReactNode } from "react";

type Tone = "steel" | "accent" | "cold" | "muted";

const TONE: Record<Tone, string> = {
    steel: "text-si-steel",
    accent: "text-si-accenthi",
    cold: "text-si-cold",
    muted: "text-si-steel",
};

/**
 * Étiquette monospace de l'univers technique (kickers de blocs, en-têtes de champs, légendes).
 */
export function TechnicalLabel({
    as: Tag = "p",
    tone = "steel",
    className = "",
    children,
    ...rest
}: {
    as?: ElementType;
    tone?: Tone;
    className?: string;
    children: ReactNode;
    [key: string]: unknown;
}) {
    const Component = Tag as ElementType<{ children?: ReactNode; className?: string }>;
    return (
        <Component className={`label-tech ${TONE[tone]} ${className}`.trim()} {...rest}>
            {children}
        </Component>
    );
}
